import Vue from "vue";
import {roundNumber} from '@/utils/number.util';

Vue.filter('spacedNumber', function (value) {
  if (value == null) return value
  const parts = value.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.join(".");
})

Vue.filter('spacedAndRoundNumber', function (value) {
  if (value == null || value === '') return value
  const rounded = roundNumber(value, 2);
  const [intPart, decPart] = rounded.toString().split('.');
  
  const spacedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  
  if (!decPart || Number(decPart) === 0) {
    return spacedInt;
  }
  
  return `${spacedInt}.${decPart.padEnd(2, '0')}`;
})
